import { NewMessagesButton } from "@albertine/design-system/components/chat";
import { useAlbertineTranslation } from "albertine-shared-web";
import { useChatPage } from "../-hooks/useChatPage";
import { useChatUnread } from "../-hooks/useChatUnreadMessages";
import { composerInsetTransition } from "../-utils/composerLayoutHeight";

export function JumpToNewMessagesButton() {
    const t = useAlbertineTranslation();
    const { composerHeight } = useChatPage();
    const { hasUnreadMessages, jumpToNewMessages } = useChatUnread();

    if (!hasUnreadMessages) {
        return null;
    }

    return (
        <NewMessagesButton
            className="absolute left-1/2 z-20 -translate-x-1/2"
            style={{
                bottom: composerHeight + 12,
                transition: composerInsetTransition("bottom"),
            }}
            onPress={jumpToNewMessages}
        >
            {t("chat.new_messages")}
        </NewMessagesButton>
    );
}
